import { COLUMNS } from '@/components/cashflow/transactions/TableRow';
import { Skeleton, Tbody, Td, Tr } from '@chakra-ui/react';

interface LoadingTrsProps {
    rowCount: number;
    columnCount: number;
}

export const LoadingTrs = ({ rowCount, columnCount }: LoadingTrsProps) => (
    <Tbody>
        {Array.from({ length: rowCount }).map((_, rowIndex) => (
            <Tr key={`row-${rowIndex}`}>
                {Array.from({ length: columnCount }).map((_, columnIndex) => (
                    <Td key={`column-${columnIndex}`} px={0}>
                        <Skeleton
                            h={5}
                            w="50%"
                            margin={
                                columnIndex === COLUMNS.length - 1
                                    ? 'auto 0 auto auto'
                                    : ''
                            }
                        />
                    </Td>
                ))}
            </Tr>
        ))}
    </Tbody>
);
